export const common = {
    methods:{
        timestampToDate(timestamp){
            var months = [
                "января",
                "февраля",
                "марта",
                "апреля",
                "мая",
                "июня",
                "июля",
                "августа",
                "сентября",
                "октября",
                "ноября",
                "декабря"
            ];
            var date = new Date(timestamp * 1000);
            return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
        },
    },
}
